import classNames from "classnames";
import styles from "./OptionPill.module.css";

export function OptionPill({
  children,
  onClick,
  isActive,
}: {
  children: React.ReactNode;
  onClick?: () => void;
  isActive?: boolean;
}) {
  return (
    <button
      onClick={onClick}
      className={classNames(styles.pill, { [styles.active]: isActive })}
      type="button"
    >
      {children}
    </button>
  );
}
